<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 24 24">
    <path
      d="M12.0109 7.2499L19.8609 15.0999L19.1509 15.8099L12.0009 8.6599L4.86092 15.8099L4.15092 15.0999L12.0009 7.2499L12.0109 7.2499Z"
      :class="colorClass"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.79736 15.0999L11.8974 6.9999L12.1145 6.9999L20.2145 15.0999L19.1509 16.1634L12.001 9.01357L4.86104 16.1636L3.79736 15.0999ZM4.86079 15.4562L12.0008 8.30622L19.1509 15.4563L19.5074 15.0999L12.0059 7.59845L4.50447 15.0999L4.86079 15.4562Z"
      :class="colorClass"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
